(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-gallery"] && !Shopify.designMode) return;
  try {
    (function(){
  var root, isUpdating = false;

  document.addEventListener('DOMContentLoaded', init);
  if(document.readyState !== 'loading') init();

  function init(){
    root = document.getElementById('monarca-cart');
    if(!root) return;
    bindQtyButtons();
    bindQtyInputs();
    bindRemoveButtons();
    bindClearAll();
    bindPromo();
  }

  function bindQtyButtons(){
    root.querySelectorAll('.mc-qty-btn').forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.preventDefault();
        if(isUpdating) return;
        var wrap = btn.closest('.mc-qty');
        var input = wrap.querySelector('.mc-qty-input');
        var key = input.dataset.key;
        var currentQty = parseInt(input.value) || 1;
        var delta = parseInt(btn.dataset.delta) || 0;
        var newQty = Math.max(0, currentQty + delta);
        updateLineQty(key, newQty);
      });
    });
  }

  function bindQtyInputs(){
    root.querySelectorAll('.mc-qty-input').forEach(function(input){
      input.addEventListener('change', function(){
        if(isUpdating) return;
        var key = input.dataset.key;
        var newQty = Math.max(0, parseInt(input.value) || 0);
        updateLineQty(key, newQty);
      });
    });
  }

  function bindRemoveButtons(){
    root.querySelectorAll('.mc-remove').forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.preventDefault();
        if(isUpdating) return;
        var key = btn.dataset.key;
        updateLineQty(key, 0);
      });
    });
  }

  function bindClearAll(){
    var btn = document.getElementById('mc-clear-all');
    if(!btn) return;
    btn.addEventListener('click', function(){
      if(isUpdating) return;
      if(!confirm('¿Vaciar todo el carrito?')) return;
      isUpdating = true;
      root.classList.add('is-updating');
      fetch('/cart/clear.js', {method:'POST'})
        .then(function(){ window.location.reload(); })
        .catch(function(){ isUpdating = false; root.classList.remove('is-updating'); });
    });
  }

  function bindPromo(){
    var input = document.getElementById('mc-promo-input');
    var btn = document.getElementById('mc-promo-btn');
    if(!input || !btn) return;
    function apply(){
      var code = (input.value || '').trim();
      if(!code) return;
      // Shopify applies discount codes at checkout via a query param
      window.location.href = '/checkout?discount=' + encodeURIComponent(code);
    }
    btn.addEventListener('click', apply);
    input.addEventListener('keydown', function(e){
      if(e.key === 'Enter'){ e.preventDefault(); apply(); }
    });
  }

  function updateLineQty(key, quantity){
    isUpdating = true;
    root.classList.add('is-updating');
    var item = root.querySelector('.mc-item[data-line-key="' + key + '"]');
    if(item && quantity === 0) item.classList.add('is-removing');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function(r){ return r.json(); })
    .then(function(){
      window.location.reload();
    })
    .catch(function(){
      isUpdating = false;
      root.classList.remove('is-updating');
      if(item) item.classList.remove('is-removing');
      alert('No se pudo actualizar el carrito. Intenta de nuevo.');
    });
  }
})();
  } catch(e) { console.error(e); }
})();

})();
